"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifiers = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_modifiers_1 = require("styled-components-modifiers");
var styled_components_1 = require("styled-components");
var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");
var Checkbox_styled_1 = require("./Checkbox.styled");
Object.defineProperty(exports, "modifiers", {
  enumerable: true,
  get: function get() {
    return Checkbox_styled_1.modifiers;
  }
});
/* HEADS UP!
 ** Checkbox has ability to be controlled or uncontrolled component based on presence of `onChange` and `value` props
 */
var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    modifiers = _ref.modifiers,
    id = _ref.id,
    value = _ref.value,
    checked = _ref.checked,
    dataNw = _ref.dataNw;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: atoms_utils_theme_1.theme
  }, react_1.default.createElement(Checkbox_styled_1.CheckStyled, {
    modifiers: modifiers
  }, react_1.default.createElement(Checkbox_styled_1.Check, {
    type: 'checkbox',
    name: name,
    id: id,
    value: value,
    checked: checked,
    onChange: onChange,
    onBlur: onBlur,
    "data-nw": dataNw
  }), react_1.default.createElement(Checkbox_styled_1.IconContainer, null, react_1.default.createElement("svg", {
    version: '1.1',
    id: 'Layer_1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
    x: '0px',
    y: '0px',
    viewBox: '0 0 10.9 8.8',
    style: {
      enableBackground: 'new 0 0 10.9 8.8'
    },
    xmlSpace: 'preserve'
  }, react_1.default.createElement("g", {
    id: 'icons_dark_check',
    transform: 'translate(0 0)'
  }, react_1.default.createElement("path", {
    id: 'Mask-2',
    d: 'M8.9,0l-1,1L4.1,4.9L3,3.8l-1-1l-2,2l1,1l2.1,2.1l1,1l1-1L9.9,3l1-1L8.9,0z'
  })))), label));
};
Checkbox.propTypes = {
  label: prop_types_1.default.any,
  name: prop_types_1.default.string,
  onChange: prop_types_1.default.func,
  onBlur: prop_types_1.default.func,
  modifiers: (0, styled_components_modifiers_1.styleModifierPropTypes)(Checkbox_styled_1.modifiers),
  id: prop_types_1.default.string,
  value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.bool]),
  checked: prop_types_1.default.bool
};
exports.default = Checkbox;